import React from 'react'
import { useTranslation } from 'react-i18next'
import { ListGroup } from 'react-bootstrap'
import { convertDateToDisplayFormat } from '../../utils/dateFormat/dateFormat'
import { PlantData } from '../../interface/response/PlantResponse'
interface PlantListItemProps {
  plantInfo: PlantData
  selectedPlant: string
  handleSelectedItem: (val: string) => void
}

const PlantListItem: React.FC<PlantListItemProps> = ({
  plantInfo,
  selectedPlant,
  handleSelectedItem,
}: PlantListItemProps) => {
  const { t } = useTranslation(['translation'])
  return (
    <ListGroup.Item
      key={plantInfo?.plantCode}
      action
      active={selectedPlant === plantInfo?.plantCode ? true : false}
      onClick={() => handleSelectedItem(plantInfo.plantCode)}
    >
      <p className="list-item-title">{plantInfo?.plantName}</p>
      <div className="list-item-created">
        <span className="list-item-created__label">
          {t('common.created_on')}
        </span>
        <span className="list-item-created__value">
          {convertDateToDisplayFormat(plantInfo?.createdDate)}
        </span>
      </div>
    </ListGroup.Item>
  )
}
export default PlantListItem
